import './index.erb';
import './index.rb';
import './components/cta.erb';

import CookieManager from 'utils/cookie_manager';
import ModalManager from 'utils/modal_manager';

import 'images/pay_wall/hourglass.svg';

class PaywallModal {
  constructor($context) {
    this.$context = $context;
    this.cookieName = 'renewal_paywall';
    this.$btnDismiss = $('.js-paywall-renewall-dismiss', this.$context);

    this.bind();
    this.bindDismiss();
  }

  dismissModal() {
    CookieManager.setExpirationCookie(this.cookieName, true, this.$context.data('daysExpires'));
  }

  bind() {
    if (this.$context.data('show') && !CookieManager.getCookie(this.cookieName)) {
      ModalManager.open('#js-paywall-modal');
    }
  }

  bindDismiss() {
    this.$btnDismiss.on('click', () => this.dismissModal());
  }
}

const init = () => new PaywallModal($('#js-paywall-modal'));

document.addEventListener('turbolinks:load', () => init());
init();
